'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExperimentsRequestsCache = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.isCacheEnabled = isCacheEnabled;
exports.getCacheInstance = getCacheInstance;

var _experimentsDataUtils = require('./experiments-data-utils');

var _urlMap = require('./urlMap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperimentsRequestsCache = exports.ExperimentsRequestsCache = function () {
  function ExperimentsRequestsCache() {
    (0, _classCallCheck3.default)(this, ExperimentsRequestsCache);

    this.urlMap = new Map();
  }

  (0, _createClass3.default)(ExperimentsRequestsCache, [{
    key: 'addUrlResponse',
    value: function addUrlResponse(url, response) {
      this.urlMap.set(url, response);
    }
  }, {
    key: 'getUrlResponse',
    value: function getUrlResponse(url) {
      return this.urlMap.get(url);
    }
  }, {
    key: 'getExperimentValue',
    value: function getExperimentValue(specName, useNewApi) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.urlMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var url = _step.value;

          if ((0, _urlMap.isUrlOfExperiment)(url, specName, useNewApi)) {
            return this.urlMap.get(url);
          } else if ((0, _urlMap.isValidScopeUrl)(url, useNewApi)) {
            var jsonObject = (0, _experimentsDataUtils.tryParse)(this.urlMap.get(url));
            if ((typeof jsonObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(jsonObject)) === 'object' && specName in jsonObject) {
              return jsonObject[specName];
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }]);
  return ExperimentsRequestsCache;
}();

function isCacheEnabled() {
  return self.useExperimentsCache;
}

function getCacheInstance() {
  if (self.experimentsCache === undefined) {
    self.experimentsCache = new ExperimentsRequestsCache();
  }

  return self.experimentsCache;
}